// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Volume } from './Volume';
import { VolumePrism } from './VolumePrism';
import { Polygon2D } from './Polygon2D';
import { Coordinate } from './Coordinate';
import { Airspace } from './Airspace';

export class PrismRange implements IPrismRange {
    lower!: number | undefined;
    upper!: number | undefined;

    constructor(data?: IPrismRange) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lower = _data["lower"];
            this.upper = _data["upper"];
        }
    }

    static fromJS(data: any): PrismRange {
        data = typeof data === 'object' ? data : {};
        let result = new PrismRange();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lower"] = this.lower;
        data["upper"] = this.upper;
        return data;
    }
}

export interface IPrismRange {
    lower: number | undefined;
    upper: number | undefined;
}